var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isAuthenticated
        ? _c("LandingHeaderV2", {
            staticClass: "logged-out-header",
            attrs: {
              "ax-params": {
                ids: {
                  headerLogInBtn:
                    "clicked_login_from_" + _vm.routeName + "_header",
                  stickyHeaderLogInBtn:
                    "clicked_login_from_" + _vm.routeName + "_sticky_header",
                  stickyHeaderSignUpBtn:
                    "clicked_get_started_from_" +
                    _vm.routeName +
                    "_sticky_header"
                }
              }
            }
          })
        : _c("AppHeader")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }